"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginApi_1 = require("@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/apis/LoginApi");
var factory = function (configuration) { return new LoginApi_1.LoginApi(configuration); };
exports.default = factory;
//# sourceMappingURL=loginApiFactory.ec.js.map